<template>
    <div class="view shipping">
		<div class="view-title">
			<div class="collection">
				<router-link to="/" v-if="isMobile" class="back">
					<button class="btn"><i class="ic ic-chevron-left"></i></button>
					<img src="@/assets/images/bps_logo_store.svg" alt="Merch Store">
				</router-link>
				<span>2019 - 2020<br>Black Pug Studio Collection</span>
			</div>
			<h1>Shipping</h1>
			<h3 v-if="isMobile">Shipping</h3>
		</div>
		<div class="sheet">
			<section class="lead panel" aria-labelledby="shipping-fact">
				<span class="rule" aria-hidden="true"></span>
				<p id="shipping-fact">Your merchandise subtotal does not include shipping and handling.</p>
			</section>
			<section class="returns" aria-labelledby="returns-title">
				<div class="section-head">
					<h2 id="returns-title">Our Return Policy</h2>
				</div>
				<div class="grid">
					<article class="card">
						<h3>Return Policy</h3>
						<p>Any claims for misprinted/damaged/defective items must be submitted within 4 weeks after the product has been received. For packages lost in transit, all claims must be submitted no later than 4 weeks after the estimated delivery date. Claims deemed an error on our part are covered at the expense of Printful.</p>
					</article>
					<article class="card">
						<h3>Wrong Address</h3>
						<p>If you provide an address that is considered insufficient by the courier, the shipment will be returned to our facility. You will be liable for reshipment costs once we have confirmed an updated address with you.</p>
					</article>
					<article class="card">
						<h3>Unclaimed</h3>
						<p>Shipments that go unclaimed are returned to our facility and you will be liable for the cost of a reshipment to yourself or your end customer. Unclaimed returns get donated to charity after 4 weeks.</p>
					</article>
					<article class="card">
						<h3>Returns</h3>
						<p>Please contact Black Pug Studio before returning any products. We can’t refund orders for buyer’s remorse, but in the case that you require a size exchange and cannot comfortably wear the apparel, please <router-link to="/contact">contact us on our website</router-link>.</p>
					</article>
					<article class="card card-eu">
						<h3>Notification for EU consumers</h3>
						<p class="eu-body">According to Article 16(c) of the Directive 2011/83/EU of the European Parliament and of the Council of 25 October 2011 on consumer rights, the right of withdrawal may not be provided for the supply of goods made to the consumer's specifications or clearly personalized, therefore Printful reserves rights to refuse returns at its sole discretion.<br>This Policy shall be governed and interpreted in accordance with the English language, regardless of any translations made for any purpose whatsoever.</p>
					</article>
				</div>
				<section class="panel return-to">
					<div class="return-note">
						<h3>Packages can be returned at this address:</h3>
					</div>
					<address>
						<span>Starta 1</span>
						<span>2nd bldg., 3rd fl.</span>
						<span>Riga, Latvia</span>
						<span>LV-1026</span>
					</address>
				</section>
			</section>
		</div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	name: "shipping",
	computed: {
		...mapGetters({
			isMobile: 'getMobile'
		})
	},
	mounted() {
		window.dispatchEvent(new CustomEvent('setLoading', {detail: {value: false}}))
	}
}
</script>

<style scoped>
.sheet {
	position: relative;
	z-index: 3;
	width: min(1120px, 100%);
	margin: 3.4vh auto 0;
	padding-bottom: 20px;
}

.panel {
	position: relative;
	background: #312C2C;
	overflow: hidden;
}

.panel:before,
.panel:after {
	content: '';
	position: absolute;
	border: 2px solid #208E7F;
	pointer-events: none;
}

.panel:before {
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1;
}

.panel:after {
	z-index: 1;
	width: 56px;
	height: 56px;
	right: -29px;
	bottom: -29px;
	background: #221F1F;
	transform: rotate(45deg);
}

.lead {
	padding: 32px 48px 40px;
	text-align: center;
}

.rule {
	display: block;
	width: 48px;
	height: 2px;
	margin: 0 auto 16px;
	background: #EDBA52;
}

.lead p {
	max-width: 28em;
	margin: 0 auto;
	font-family: 'Inter', Helvetica, Arial, sans-serif;
	font-size: 22px;
	font-weight: 500;
	line-height: 1.45;
}

.section-head {
	display: flex;
	align-items: center;
	gap: 16px;
	margin: 28px 0 16px;
}

.section-head h2 {
	margin: 0;
	color: #EDBA52;
	font-family: 'Inter', Helvetica, Arial, sans-serif;
	font-size: 13px;
	font-weight: 600;
	letter-spacing: 0.14em;
	line-height: 1.2;
	text-transform: uppercase;
	white-space: nowrap;
}

.section-head:after {
	content: '';
	flex: 1;
	height: 1px;
	background: rgba(237, 186, 82, 0.4);
}

.grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
}

.card {
	min-width: 0;
	padding: 20px 22px 22px;
	background: #2C2929;
	border: 1px solid rgba(32, 142, 127, 0.4);
	border-top: 3px solid #208E7F;
}

.card-eu {
	grid-column: 1 / -1;
}

.card h3 {
	margin: 0 0 10px;
	color: #249E8E;
	font-family: 'Inter', Helvetica, Arial, sans-serif;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.08em;
	line-height: 1.3;
	text-transform: uppercase;
}

.card p {
	margin: 0;
	color: rgba(255, 255, 255, 0.88);
	font-family: 'Inter', Helvetica, Arial, sans-serif;
	font-size: 15px;
	line-height: 1.55;
}

.eu-body {
	column-count: 2;
	column-gap: 36px;
	column-fill: balance;
}

.card a {
	color: #EDBA52;
	text-decoration-line: underline;
	text-decoration-color: rgba(237, 186, 82, 0.45);
	text-decoration-thickness: 1px;
	text-underline-offset: 0.18em;
	transition: color .16s ease-out, text-decoration-color .16s ease-out;
}

.card a:hover,
.card a:focus-visible {
	color: #F3D48A;
	text-decoration-color: currentColor;
}

.card a:focus {
	outline: 2px solid #FAFAFA;
	outline-offset: 3px;
}

.card a:focus:not(:focus-visible) {
	outline: none;
}

.return-to {
	display: flex;
	align-items: stretch;
	margin-top: 16px;
}

.return-note,
.return-to address {
	position: relative;
	z-index: 2;
	min-width: 0;
}

.return-note {
	flex: 1.15 1 0;
	display: flex;
	align-items: center;
	padding: 28px 28px 36px;
}

.return-note h3 {
	margin: 0;
	max-width: 16em;
	color: #fff;
	font-family: 'Inter', Helvetica, Arial, sans-serif;
	font-size: 20px;
	font-weight: 600;
	line-height: 1.35;
}

.return-to address {
	flex: 0.85 1 0;
	margin: 0;
	padding: 28px 52px 40px 28px;
	border-left: 2px solid #208E7F;
	color: #fff;
	font-style: normal;
	font-family: 'Inter', Helvetica, Arial, sans-serif;
	font-size: 16px;
	line-height: 1.5;
}

.return-to address span {
	display: block;
	opacity: 0.77;
}

.return-to address span:first-child {
	opacity: 1;
	font-weight: 600;
}

@media screen and (max-width: 1360px) {
	.sheet {
		width: 100%;
		padding-left: 40px;
		padding-right: 40px;
	}
}

@media screen and (max-width: 1023px) {
	.view {
		display: block;
		height: auto;
	}

	.sheet {
		width: auto;
		margin: 0;
		padding: 108px 32px 12px;
	}

	.lead {
		padding: 26px 24px 32px;
	}

	.lead p {
		font-size: 18px;
	}

	.section-head {
		margin: 28px 0 14px;
	}

	.grid {
		grid-template-columns: 1fr;
	}

	.card-eu {
		grid-column: auto;
	}

	.card p {
		font-size: 15px;
	}

	.return-to {
		flex-direction: column;
	}

	.return-note {
		padding: 24px 24px 20px;
	}

	.return-note h3 {
		font-size: 18px;
	}

	.return-to address {
		padding: 20px 36px 32px 24px;
		border-left: 0;
		border-top: 2px solid #208E7F;
		font-size: 16px;
	}

	.panel:after {
		width: 48px;
		height: 48px;
		right: -25px;
		bottom: -25px;
	}
}

@media screen and (max-width: 640px) {
	.eu-body {
		column-count: 1;
	}
}

@media screen and (max-width: 410px) {
	.sheet {
		padding: 100px 24px 8px;
	}

	.lead {
		padding: 22px 18px 28px;
	}

	.lead p {
		font-size: 17px;
	}

	.section-head h2 {
		font-size: 12px;
		letter-spacing: 0.1em;
	}

	.card {
		padding: 18px 16px 18px;
	}

	.card h3 {
		font-size: 11px;
	}

	.card p {
		font-size: 14px;
	}

	.return-note {
		padding: 20px 18px 16px;
	}

	.return-note h3 {
		font-size: 16px;
	}

	.return-to address {
		padding: 16px 28px 28px 18px;
		font-size: 15px;
	}
}
</style>
